import { render, staticRenderFns } from "./FactCard.vue?vue&type=template&id=431674b2"
import script from "./FactCard.vue?vue&type=script&lang=js"
export * from "./FactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports